import * as AccessibleIcon from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

const Download: React.FC<SVGProps<SVGSVGElement>> = props => {
  const label = 'download'
  return (
    <AccessibleIcon.Root label={label}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
          d="M10 2.5C10.3315 2.5 10.6495 2.6317 10.8839 2.86612C11.1183 3.10054 11.25 3.41848 11.25 3.75V10.5858L12.7929 9.04289C13.1834 8.65237 13.8166 8.65237 14.2071 9.04289C14.5976 9.43342 14.5976 10.0666 14.2071 10.4571L10.7071 13.9571C10.3166 14.3476 9.68342 14.3476 9.29289 13.9571L5.79289 10.4571C5.40237 10.0666 5.40237 9.43342 5.79289 9.04289C6.18342 8.65237 6.81658 8.65237 7.20711 9.04289L8.75 10.5858V3.75C8.75 3.41848 8.8817 3.10054 9.11612 2.86612C9.35054 2.6317 9.66848 2.5 10 2.5Z"
          fill="currentColor"
        />
        <path
          d="M3.75 15.625C3.41848 15.625 3.10054 15.7567 2.86612 15.9911C2.6317 16.2255 2.5 16.5435 2.5 16.875V17.5C2.5 17.8315 2.6317 18.1495 2.86612 18.3839C3.10054 18.6183 3.41848 18.75 3.75 18.75H16.25C16.5815 18.75 16.8995 18.6183 17.1339 18.3839C17.3683 18.1495 17.5 17.8315 17.5 17.5V16.875C17.5 16.5435 17.3683 16.2255 17.1339 15.9911C16.8995 15.7567 16.5815 15.625 16.25 15.625H3.75Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon.Root>
  )
}

export default Download

